<mat-form-field
    subscriptSizing="dynamic"
    class="st-simple-search-box__form-field">
    <input
        class="st-simple-search-box__input"
        matInput
        matAutocompleteTrigger
        [placeholder]="languageSettings().PSTWebSearchPlaceholder"
        [matAutocomplete]="auto"
        [(ngModel)]="searchTherm"
        (change)="searchChanged()" />
    <button
        matPrefix
        mat-icon-button
        class="st-simple-search-box-toggle"
        [matTooltip]="languageSettings().PSTWebSearchLabel"
        (click)="executeSearch()">
        <mat-icon>search</mat-icon>
    </button>
    <button
        class="st-simple-search-box-close"
        matSuffix
        mat-icon-button
        (click)="clearSearch()">
        <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selectSuggestion($event)">
        @for (item of suggestions(); track item?.value; let idx = $index) {
            <mat-option
                class="st-simple-search-box-suggestion-option"
                [value]="item.value">
                <div class="st-simple-search-box-suggestion">
                    @if (item.type === SuggestionType.STAFF) {
                        <st-avatar
                            class="st-simple-search-box-suggestion-avatar"
                            big
                            [userId]="item.value" />
                    }
                    <span class="st-simple-search-box-suggestion-label"> {{ item.label }} </span>
                </div>
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
